import {
  createAsyncThunk,
  createEntityAdapter,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';


const postsAdapter = createEntityAdapter({
	sortComparer: (a, b) => b.createdAt - a.createdAt
});

const channelAppSlice = createSlice({
  name: 'channelApp/channel',
  initialState: {
	  commentPanelPostId: null,
	  searchText: "",
	  searchResults: postsAdapter.getInitialState(),
  },
  reducers: {
    setCommentPanelPostId: {
      reducer: (state, action) => {
        state.commentPanelPostId = action.payload;
      }
    },
    setSearchText: {
      reducer: (state, action) => {
        state.searchText = action.payload;
      }
    },
    setSearchResults: {
      reducer: (state, action) => {
		postsAdapter.setAll(state.searchResults, action.payload)
      }
    },
    clearSearch: {
      reducer: (state, action) => {
		state.searchResults= postsAdapter.getInitialState();
		state.searchText= "";
      }
    },
  },
});

export const { selectAll: selectSearchResults } = postsAdapter.getSelectors(state => state.channelApp.channel.searchResults);

export const selectCommentPanelPostId = () => state => {
	return state.channelApp.channel.commentPanelPostId;
}

export const selectSearchText = state => {
	return state.channelApp.channel.searchText;
}

export const { setCommentPanelPostId, setSearchText, setSearchResults, clearSearch} = channelAppSlice.actions;

export default channelAppSlice.reducer;
